import api from "../../utils/apiUserTienda";

export const getZonasEnvio = async ({ page = 1, limit = 20 } = {}) => {
  const res = await api.get("/api/tienda/zonas_envio/obtener", {
    params: { page, limit },
  });
  return res.data;
};

export const crearZonaEnvio = async (data) => {
  const res = await api.post("/api/tienda/zonas_envio/crear", data);
  return res.data;
};

export const actualizarZonaEnvio = async (id, data) => {
  const res = await api.put(`/api/tienda/zonas_envio/actualizar/${id}`, data);
  return res.data;
};

export const obtenerZonaEnvioPorId = async (id) => {
  const res = await api.get(`/api/tienda/zonas_envio/obtener/${id}`);
  return res.data;
}; 

export const getZonasEnvioActivas = async () => {
  const res = await api.get("/api/tienda/zonas_envio/obtener/activas"); 
  return res.data;
};
